const getURL = (userId, name) => {
    if (!userId || !name) {
        return null;
    }
    return `${process.env.REACT_APP_MEDIA_SERVICE_URL}${process.env.REACT_APP_MEDIA_FILE_PATTERN_USER}`
        .replace('{userId}', userId).replace('{name}', name)
}

const UserUtils = {
    getImageUrl: (userId, imageName) => getURL(userId, imageName),
}

export default UserUtils;